import { authFetch } from "~/services/fetch";

// ! GRÁFICO DE PIZZA
export async function getOccurrencesAssociatedWeaponByType({
  startDate,
  finishDate,
  weaponTypeId,
  circumstanceId,
  destinationId,
  weaponKindId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-weapon-by-type',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        weapon_type_id: weaponTypeId,
        destination_id: destinationId,
        circumstance_id: circumstanceId,
        weapon_kind_id: weaponKindId
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedWeaponByCircunstance({
  startDate,
  finishDate,
  weaponTypeId,
  circumstanceId,
  destinationId,
  weaponKindId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-weapon-by-circunstance',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        weapon_type_id: weaponTypeId,
        destination_id: destinationId,
        circumstance_id: circumstanceId,
        weapon_kind_id: weaponKindId
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedWeaponByDestination({
  startDate,
  finishDate,
  weaponTypeId,
  circumstanceId,
  destinationId,
  weaponKindId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-weapon-by-destination',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        weapon_type_id: weaponTypeId,
        destination_id: destinationId,
        circumstance_id: circumstanceId,
        weapon_kind_id: weaponKindId
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedWeaponByOccurrenceType({
  startDate,
  finishDate,
  weaponTypeId,
  circumstanceId,
  destinationId,
  weaponKindId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-weapon-by-occurrence-type',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        weapon_type_id: weaponTypeId,
        destination_id: destinationId,
        circumstance_id: circumstanceId,
        weapon_kind_id: weaponKindId
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}

export async function getOccurrencesAssociatedWeaponByKindType({
  startDate,
  finishDate,
  weaponTypeId,
  circumstanceId,
  destinationId,
  weaponKindId
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/occurrences-associated-weapon-by-kind',
      method: 'POST',
      data: {
        start_date: startDate,
        finish_date: finishDate,
        weapon_type_id: weaponTypeId,
        destination_id: destinationId,
        circumstance_id: circumstanceId,
        weapon_kind_id: weaponKindId
      }
    })
    return data;
  } catch (error) {
    throw error
  }
}


